import React from "react";
import noAccessIcon from "../../assets/images/noAccess.svg";

function NoaccessLeadCard() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        maxHeight: "calc(98vh - 140px)",
        minHeight: " calc(98vh - 140px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
          height: "100%",
        }}
      >
        <div style={{ maxWidth: "100%", padding: "30px" }}>
          <img src={noAccessIcon} alt="noAccessIcon" />
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#142C44",
              marginBottom: "15px",
            }}
          >
            You don’t have permission to access this lead
          </div>
          <div style={{ fontSize: "13px", color: "#667085" }}>
            The lead belongs to different branch
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoaccessLeadCard;
